import { render, staticRenderFns } from "./info-tip.vue?vue&type=template&id=93be0138&scoped=true"
import script from "./info-tip.vue?vue&type=script&lang=js"
export * from "./info-tip.vue?vue&type=script&lang=js"
import style0 from "./info-tip.vue?vue&type=style&index=0&id=93be0138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93be0138",
  null
  
)

export default component.exports